import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_ADMINUSERS_REQUEST, GET_ADMINUSERS_SUCCESS, GET_ADMINUSERS_FAILURE,
    GET_ADMINUSER_REQUEST, GET_ADMINUSER_SUCCESS, GET_ADMINUSER_FAILURE,
    ADD_ADMINUSER_REQUEST, ADD_ADMINUSER_SUCCESS, ADD_ADMINUSER_FAILURE,
    EDIT_ADMINUSER_REQUEST, EDIT_ADMINUSER_SUCCESS, EDIT_ADMINUSER_FAILURE,
    DELETE_ADMINUSER_REQUEST, DELETE_ADMINUSER_SUCCESS, DELETE_ADMINUSER_FAILURE,
    SET_ADD_ADMINUSER_POPUP, SET_EDIT_ADMINUSER_POPUP, SET_DELETE_ADMINUSER_POPUP,
    RESET_ADMINUSER_STATE
} from '../actions/adminUsers.action';


export interface AdminUser {
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    adminType: string | "admin";
    isActive?: boolean;
}

export interface State {
    adminUsers: AdminUser[];
    adminUser: AdminUser | {};
    loading: boolean;
    error: string | null;
    addAdminUserLoading: boolean;
    editAdminUserLoading: boolean;
    deleteAdminUserLoading: boolean;
    addPopupOpen: boolean;
    editPopupOpen: boolean;
    deletePopupOpen: boolean;

}

const initialState: State = {
    adminUsers: [],
    adminUser: {},
    loading: false,
    addAdminUserLoading: false,
    editAdminUserLoading: false,
    deleteAdminUserLoading: false,
    error: null,
    addPopupOpen: false,
    editPopupOpen: false,
    deletePopupOpen: false,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMINUSERS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_ADMINUSERS_SUCCESS:
            return { ...state, adminUsers: action.payload, loading: false, error: null };
        case GET_ADMINUSERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_ADMINUSER_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_ADMINUSER_SUCCESS:
            return { ...state, adminUser: action.payload, loading: false, error: null };
        case GET_ADMINUSER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ADD_ADMINUSER_REQUEST:
            return { ...state, addAdminUserLoading: true };
        case ADD_ADMINUSER_SUCCESS:
            return { ...state, addAdminUserLoading: false };
        case ADD_ADMINUSER_FAILURE:
            return { ...state, addAdminUserLoading: false };
        case EDIT_ADMINUSER_REQUEST:
            return { ...state, editAdminUserLoading: true };
        case EDIT_ADMINUSER_SUCCESS:
            return { ...state, editAdminUserLoading: false };
        case EDIT_ADMINUSER_FAILURE:
            return { ...state, editAdminUserLoading: false };
        case DELETE_ADMINUSER_REQUEST:
            return { ...state, deleteAdminUserLoading: true };
        case DELETE_ADMINUSER_SUCCESS:
            return { ...state, deleteAdminUserLoading: false };
        case DELETE_ADMINUSER_FAILURE:
            return { ...state, deleteAdminUserLoading: false };
        case SET_ADD_ADMINUSER_POPUP:
            return { ...state, addPopupOpen: action.payload };
        case SET_EDIT_ADMINUSER_POPUP:
            return { ...state, editPopupOpen: action.payload };
        case SET_DELETE_ADMINUSER_POPUP:
            return { ...state, deletePopupOpen: action.payload };
        case RESET_ADMINUSER_STATE:
            return {...initialState}
        default:
            return state;
    }
};

export default reducer;
